import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from 'stores/rematch/root-store';
import { ActionIcon, Badge, Group, Tabs, Text } from '@good/ui/core';
import { Bookmark, Undo } from '@good/icons';
import { ICustomView } from 'interfaces/custom-views-interface';
import { BookingViewTabActionIcon } from './booking-view-tab-action-icon';
import { BookingView } from 'stores/rematch/models/types/bookings-store';
import { CustomViewsModalType } from 'utilities/enum-utils';
import { useBookingTabs } from 'views/bookings-v2/books-view-context/booking-tab-view-context';

type BookingViewTabsTabProps = {
  tab: BookingView | ICustomView;
  disabled?: boolean;
  selected?: boolean;
} & (
  | {
      custom?: false;
      openBookingViewModal?: never;
    }
  | { custom: true; openBookingViewModal: (type: CustomViewsModalType) => void }
);

const modifiedColor = 'lilac';

export const BookingViewTabsTab = ({
  tab,
  disabled,
  custom,
  openBookingViewModal,
  selected,
}: BookingViewTabsTabProps) => {
  const { customViewId, isPinned } = tab;
  const filterCounters = useSelector((state: IRootState) => state.bookingsStore.filterCounters);
  const counter = _.find(filterCounters, (counter) => counter.filterName === customViewId);
  const dirty = useBookingTabs((selector) => selector.dirtyIds.includes(customViewId || ''));
  const onRevert = useBookingTabs((selector) => selector.revertViewSnapshot);

  if (!customViewId) {
    return null;
  }

  return (
    <Tabs.Tab disabled={disabled} key={customViewId} value={customViewId}>
      <Group wrap='nowrap' gap={6}>
        {custom && isPinned && (
          <Group wrap='nowrap' gap={6}>
            <Bookmark />
          </Group>
        )}
        <Text inherit fw={selected ? 550 : undefined}>
          {tab.name}
        </Text>
        {dirty && (
          <Badge
            color={selected ? modifiedColor : 'gray'}
            c={selected ? modifiedColor : undefined}
            variant='outline'
            radius='sm'
            pr={selected ? 0 : undefined}
            rightSection={
              selected && (
                <ActionIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    onRevert(customViewId);
                  }}
                  size={18}
                  w={28}
                  variant='light'
                  color={modifiedColor}
                  fz={12}
                  radius={0}
                  ml={4}
                >
                  <Undo />
                </ActionIcon>
              )
            }
          >
            Modified
          </Badge>
        )}
        {counter !== undefined && (
          <Badge color='gray.1' c='dark'>
            {counter.count}
          </Badge>
        )}

        {custom && openBookingViewModal && (
          <BookingViewTabActionIcon tab={tab as ICustomView} openBookingViewModal={openBookingViewModal} />
        )}
      </Group>
    </Tabs.Tab>
  );
};
